(function () {
  const DURATION_MS = 300;
  const EASING = 'ease';

  function prefersReducedMotion() {
    // TODO: 一時的に無効化（アニメーション動作確認用）
    return false;
    // return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getSummary(details) {
    return details.querySelector('summary');
  }

  function getContent(details) {
    return details.querySelector('.accordion__content');
  }

  function clearInlineStyles(details, content) {
    details.style.removeProperty('height');
    details.style.removeProperty('overflow');
    if (content) {
      content.style.removeProperty('opacity');
    }
  }

  function cancelAnimations(state) {
    if (!state.animations || state.animations.length === 0) return;
    state.animations.forEach((animation) => {
      try {
        animation.cancel();
      } catch (error) {
        /* ignore */
      }
    });
    state.animations = [];
  }

  function runAnimations(state, animations) {
    cancelAnimations(state);
    state.animations = animations;
    return Promise.all(
      animations.map(
        (animation) =>
          new Promise((resolve) => {
            animation.onfinish = () => resolve();
            animation.oncancel = () => resolve();
          })
      )
    );
  }

  function openDetails(details, state, options) {
    const summary = getSummary(details);
    const content = getContent(details);
    if (!summary || !content) return Promise.resolve();

    const fromHeight = options && options.fromHeight;

    if (prefersReducedMotion()) {
      cancelAnimations(state);
      state.isExpanding = false;
      state.isClosing = false;
      details.setAttribute('open', '');
      clearInlineStyles(details, content);
      return Promise.resolve();
    }

    state.isExpanding = true;
    state.isClosing = false;
    const generation = ++state.generation;

    details.setAttribute('open', '');

    const startHeight = fromHeight != null ? fromHeight : summary.offsetHeight;
    const startOpacity =
      fromHeight != null ? Number.parseFloat(window.getComputedStyle(content).opacity) || 0 : 0;

    details.style.overflow = 'hidden';
    details.style.height = `${startHeight}px`;
    content.style.opacity = String(startOpacity);

    const endHeight = details.scrollHeight;

    const heightAnimation = details.animate(
      [{ height: `${startHeight}px` }, { height: `${endHeight}px` }],
      { duration: DURATION_MS, easing: EASING, fill: 'forwards' }
    );

    const opacityAnimation = content.animate(
      [{ opacity: startOpacity }, { opacity: 1 }],
      { duration: DURATION_MS, easing: EASING, fill: 'forwards' }
    );

    return runAnimations(state, [heightAnimation, opacityAnimation]).then(() => {
      if (generation !== state.generation) return;
      cancelAnimations(state);
      clearInlineStyles(details, content);
      state.isExpanding = false;
    });
  }

  function closeDetails(details, state, options) {
    const summary = getSummary(details);
    const content = getContent(details);
    if (!summary || !content) return Promise.resolve();

    const fromHeight = options && options.fromHeight;

    if (prefersReducedMotion()) {
      cancelAnimations(state);
      state.isExpanding = false;
      state.isClosing = false;
      details.removeAttribute('open');
      clearInlineStyles(details, content);
      return Promise.resolve();
    }

    if (!details.hasAttribute('open')) {
      state.isClosing = false;
      clearInlineStyles(details, content);
      return Promise.resolve();
    }

    state.isClosing = true;
    state.isExpanding = false;
    const generation = ++state.generation;

    const startHeight = fromHeight != null ? fromHeight : details.offsetHeight;
    const endHeight = summary.offsetHeight;
    const startOpacity =
      fromHeight != null ? Number.parseFloat(window.getComputedStyle(content).opacity) || 1 : 1;

    details.style.overflow = 'hidden';
    details.style.height = `${startHeight}px`;
    content.style.opacity = String(startOpacity);

    const heightAnimation = details.animate(
      [{ height: `${startHeight}px` }, { height: `${endHeight}px` }],
      { duration: DURATION_MS, easing: EASING, fill: 'forwards' }
    );

    const opacityAnimation = content.animate(
      [{ opacity: startOpacity }, { opacity: 0 }],
      { duration: DURATION_MS, easing: EASING, fill: 'forwards' }
    );

    return runAnimations(state, [heightAnimation, opacityAnimation]).then(() => {
      if (generation !== state.generation) return;
      cancelAnimations(state);
      details.removeAttribute('open');
      clearInlineStyles(details, content);
      state.isClosing = false;
    });
  }

  function initDetails(details) {
    const summary = getSummary(details);
    if (!summary) return;

    const state = {
      animations: [],
      isClosing: false,
      isExpanding: false,
      generation: 0,
    };

    summary.addEventListener('click', (event) => {
      event.preventDefault();

      const content = getContent(details);
      const isAnimating = state.isExpanding || state.isClosing || state.animations.length > 0;

      let targetOpen;
      if (state.isExpanding) {
        targetOpen = false;
      } else if (state.isClosing) {
        targetOpen = true;
      } else {
        targetOpen = !details.hasAttribute('open');
      }

      let resumeOptions;
      if (isAnimating) {
        cancelAnimations(state);
        state.generation += 1;
        const currentHeight = details.offsetHeight;
        details.style.overflow = 'hidden';
        details.style.height = `${currentHeight}px`;
        resumeOptions = { fromHeight: currentHeight };
        state.isExpanding = false;
        state.isClosing = false;
      }

      if (targetOpen) {
        openDetails(details, state, resumeOptions);
        return;
      }

      closeDetails(details, state, resumeOptions);
    });
  }

  function initAccordionRoot(root) {
    if (!root || root.dataset.accordionInit === 'true') return;
    root.dataset.accordionInit = 'true';
    root.querySelectorAll('details').forEach(initDetails);
  }

  function initAllAccordions() {
    document.querySelectorAll('.product-metafields-accordions').forEach(initAccordionRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllAccordions);
  } else {
    initAllAccordions();
  }
})();
